export default __webpack_public_path__ + "static/media/landscape31.764b78fe.jpeg";